/**
 * 计价查询的最小结构：只需 id + creditsPerUse（完整 Model、含「默认对话模型」等
 * 无 supportedModes 的精简条目均可传入）。
 */
export interface CostLookupModel {
  id: string;
  /** /api/models 叠加的单次调用积分价（定价表 model_credit_pricing，未配置 = 0 免费） */
  creditsPerUse?: number;
  /** 同名聚合条目的变体 id 列表（存量数据可能仍引用某个变体 id，如 -vip） */
  variantIds?: string[];
  /** 分辨率档位（小写）→ 实际单价；同名变体按档位计不同价（如 1K=2、2K/4K=4）时由聚合层提供 */
  pricingByResolution?: Record<string, number>;
}

/**
 * 积分系统 P1 前端共用工具（积分系统开发方案 v1.10 七节）：
 * 单模型费用 = /api/models 叠加的 creditsPerUse（定价表 model_credit_pricing）；
 * 未配置定价 / 未命中模型 = 0（免费）。⚡占位展示与批量生成（单价 × N）共用此函数。
 * 同名聚合增强：modelId 命中变体 id 时经 variantIds 反查聚合条目；传入 resolution 且
 * 条目声明了 pricingByResolution 时按档位取价（未配置该档位回退 creditsPerUse）。
 */
export function getModelCost(
  modelId: string | null | undefined,
  models: CostLookupModel[],
  resolution?: string | null,
): number {
  if (!modelId) return 0;
  const model = models.find((m) => m.id === modelId || m.variantIds?.includes(modelId));
  if (!model) return 0;
  const resKey = (resolution || '').trim().toLowerCase();
  if (resKey && model.pricingByResolution) {
    const cost = model.pricingByResolution[resKey];
    if (cost !== undefined) return cost;
  }
  return model.creditsPerUse ?? 0;
}

/**
 * 402 积分不足直达会员页（积分系统开发方案 v1.10 七节）：
 * MembershipModal 仅由 UserMenu 本地 state 控制，而 UserMenu 挂载于三处全局顶栏
 * （EditorLayout / HomeTopBar / TopNavigation），故用 window CustomEvent 跨组件派发。
 */
export const OPEN_MEMBERSHIP_EVENT = 'bongai:open-membership';

export function requestOpenMembership(): void {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(OPEN_MEMBERSHIP_EVENT));
  }
}
